import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, memo, Suspense, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { ErrorBoundary } from 'shared/components/error-boundary';
import branding from 'shared/app/model/branding';
import { LegacyDevice } from 'console/device/device';
import { useAppSelector, usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { selectCurrentDeviceName } from 'console/redux/selectors';
import { Box } from '@mui/material';
import { TrackingPeriodWidget } from 'pages/tab.map/ui/components/period-widget';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { useWakeLockElement } from 'pages/tab.map/lib/wake-lock';
import { DevicePermission } from 'console/device/device_ts';
const LazyLargeMapTab = lazy(() => import(
// webpackChunkName: 'large-map-tab'
'./large'));
const LazySmallMapTab = lazy(() => import(
// webpackChunkName: 'small-map-tab'
'./small'));
export const LazyMapTab = memo(function LazyMapTab(props) {
    const containerRef = useRef(null);
    const { r_device, large, active } = props;
    const device_name = usePartialAppSelector(selectCurrentDeviceName, r_device.id);
    const onClickPrint = useReactToPrint({
        content: () => containerRef.current,
        onBeforeGetContent: async () => {
            if (containerRef.current) {
                containerRef.current.style.width = `${containerRef.current.offsetWidth}px`;
                containerRef.current.style.maxHeight = `${containerRef.current.offsetHeight}px`;
                containerRef.current.style.height = '100%';
            }
            await new Promise((resolve) => setTimeout(resolve, 1e2));
        },
        documentTitle: `${branding.name}: Карта`,
        onAfterPrint: () => {
            if (containerRef.current) {
                containerRef.current.style.width = 'auto';
                containerRef.current.style.maxHeight = 'auto';
            }
        },
        removeAfterPrint: true,
    });
    const history_available = useAppSelector((state) => LegacyDevice.has_access(state.account.id, r_device, [DevicePermission.view_gps]));
    useWakeLockElement(active);
    return (_jsx(Suspense, { fallback: _jsx("div", { className: "map-tab-loading", children: _jsx("div", { children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043A\u0430\u0440\u0442\u044B..." }) }), children: _jsx(ErrorBoundary, { children: _jsxs(Box, { className: "map-tab-container", display: "flex", flexGrow: 1, position: "relative", height: "100%", ref: containerRef, children: [_jsx("div", { className: "page-header", children: device_name }), history_available && (_jsx("div", { className: "ui-map-tab-controls", children: _jsx(TrackingPeriodWidget, { printClick: onClickPrint, device_id: r_device.id, show_print_button: isMediumUI() }) })), large ? (_jsx(LazyLargeMapTab, { history_available: history_available, device_id: r_device.id })) : (_jsx(LazySmallMapTab, { history_available: history_available, device_id: r_device.id }))] }) }) }));
});
